<div class="tw-fixed tw-bg-white tw-border-b tw-w-full tw-z-20 tw-shadow-sm">
  <div class="tw-p-3 tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-4">
    <div>
      <h1 class="tw-text-2xl tw-font-medium tw-text-blue-950">
        Business Profile
      </h1>
      <span class="tw-text-sm tw-capitalize tw-text-gray-500">
        Manage your personal information & security settings
      </span>
    </div>
    <div class="tw-flex tw-items-center tw-justify-end tw-gap-2">
      @if (!forClient && !isIframe) {
      <a href="https://www.youtube.com/watch?v=f33MWBefYYE&list=PLg3iyXzryUksrB2HU3IBYXPqerx_oSA7o" target="_blank"
        class="tw-btn-outline-primary tw-flex tw-items-center tw-gap-1 tw-text-sm">
        <i
          class="ph-fill ph-youtube-logo bg-white tw-text-md tw-text-red11za tw-w-2 tw-h-2 tw-flex tw-items-center tw-justify-center tw-me-1"></i>
        Watch Tutorial
      </a>
      }
      @if(CompanyProfilePermission.insertUpdate){
      <button (click)="syncChanges()" type="button" class="tw-btn-primary tw-flex tw-items-center tw-gap-1 tw-text-sm">
        <i class="ph-bold ph-arrows-clockwise"></i>
        Sync Changes
      </button>
      }
    </div>
  </div>
</div>

<div class="tw-w-full tw-px-4">
  <div class="tw-bg-white tw-rounded-lg tw-shadow tw-mt-[200px] md:tw-mt-[100px]">
    @for (item of accountData; track $index) {
    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-6 tw-gap-4 tw-p-4">
      <!-- Registered Number -->
      <div class="tw-flex tw-flex-col lg:tw-border-e tw-border-gray-300">
        <span class="tw-text-gray-600 tw-font-medium">Registered Number</span>
        <span class="tw-text-gray-900 tw-text-sm">
          {{ item.phoneNumber }}
        </span>
      </div>
      <!-- Verified Name -->
      <div class="tw-flex tw-flex-col lg:tw-border-e tw-border-gray-300">
        <span class="tw-text-gray-600 tw-font-medium">Verified Name</span>
        <span class="tw-text-gray-900 tw-text-sm">
          {{ item.verifiedName }}
        </span>
      </div>
      <!-- Status -->
      <div class="tw-flex tw-flex-col lg:tw-border-e tw-border-gray-300">
        <span class="tw-text-gray-600 tw-font-medium">Status</span>
        <span class="tw-text-green-500 tw-text-sm tw-font-semibold">
          {{ item.status }}
        </span>
      </div>
      <!-- Messaging Tier -->
      <div class="tw-flex tw-flex-col lg:tw-border-e tw-border-gray-300">
        <span class="tw-text-gray-600 tw-font-medium">Messaging Tier</span>
        <span class="tw-text-gray-900 tw-text-sm">
          {{ item.messagingTier }}
          {{
          item.messagingTier == 'TIER_50'
          ? '(50 Messages / 24hrs)'
          : item.messagingTier == 'TIER_250'
          ? '(250 Messages / 24hrs)'
          : item.messagingTier == 'TIER_1K'
          ? '(1,000 Messages / 24hrs)'
          : item.messagingTier == 'TIER_10K'
          ? '(10,000 Messages / 24hrs)'
          : ''
          }}
        </span>
      </div>
      <!-- Quality Rating -->
      <div class="tw-flex tw-flex-col lg:tw-border-e tw-border-gray-300">
        <span class="tw-text-gray-600 tw-font-medium">Quality Rating</span>
        <span class="tw-text-green-500 tw-text-sm tw-font-semibold">
          {{ item.qualityRating }}
        </span>
      </div>
      <!-- Account Mode -->
      <div class="tw-flex tw-flex-col">
        <span class="tw-text-gray-600 tw-font-medium">Account Mode</span>
        <span class="tw-text-gray-900">
          {{ item.accountMode }}
        </span>
      </div>
    </div>
    <div class="tw-border-t tw-border-gray-200"></div>
    }
  </div>

  @if (profileData) {
  <div class="tw-flex tw-my-3 tw-gap-4">
    <div class="lg:tw-w-3/4 tw-w-full tw-mb-3">
      <div class="tw-bg-white tw-rounded-lg tw-shadow">
        <div class="tw-p-3 tw-border-b tw-border-gray-200">
          <h1 class="tw-text-md tw-font-semibold">
            WhatsApp Business Account
          </h1>
          <span class="tw-text-xs tw-text-gray-500">
            Update WhatsApp Business & Contact Information
          </span>
        </div>
        <div class="tw-p-4">
          <!-- WhatsApp Business Display Name -->
          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              WhatsApp Business display name <code class="tw-text-red-500">*</code>
            </label>
            <input type="text" id="bName" disabled placeholder="Enter your display name"
              [value]="accountData[0]?.verifiedName"
              class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-bg-gray-100 tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 focus:tw-outline-none" />
          </div>
          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Brand image
            </label>
            <div class="tw-mt-1">
              <input type="file" id="bName" name="" accept="image/*" [disabled]="!CompanyProfilePermission.insertUpdate"
                (change)="onFileSelected($event)" class="tw-block tw-w-full tw-text-sm
             file:tw-mr-4 file:tw-px-4 file:tw-py-2
             file:tw-rounded-md file:tw-border-0
             file:tw-text-sm file:tw-font-medium
             file:tw-bg-gray-100 file:tw-text-gray-700
             hover:file:tw-bg-gray-200
             tw-border tw-border-gray-300 tw-rounded-md
             focus:tw-outline-none" />
              <small class="tw-mt-1 tw-block tw-text-xs tw-text-gray-500">
                (minimum 500px × 500px, recommended 640px × 640px, max 5 MB)
                Image should be squared, otherwise it will be cropped by WhatsApp.
              </small>
            </div>
          </div>
          <!-- Business Description -->

          <div class="">
            <label for="bDesc" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Business Description
            </label>
            <textarea id="bDesc" [(ngModel)]="profileData.businessDetails.description" maxlength="256"
              [disabled]="!CompanyProfilePermission.insertUpdate"
              class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary"></textarea>
            <span class="tw-mt-1 tw-flex tw-justify-end tw-text-xs tw-text-gray-500">
              {{ profileData.businessDetails.description?.length || 0 }} / 256 characters
            </span>
          </div>

          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Business address
            </label>
            <input type="text" id="bName" [(ngModel)]="profileData.businessDetails.address" maxlength="256"
              [disabled]="!CompanyProfilePermission.insertUpdate" placeholder="Enter your display name"
              class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary" />
            <div class="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-500">
              <span>
                Street, house number, zip code, city, state, country
              </span>
              <span>
                {{ profileData.businessDetails.address?.length || 0 }} / 256 character
              </span>
            </div>
          </div>
          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Business category
            </label>
            <select id="bName" [(ngModel)]="profileData.businessDetails.vertical"
              [disabled]="!CompanyProfilePermission.insertUpdate" class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-bg-white 
           tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary">
              <option value="">Please select</option>
              <option value="Automotive">Automotive</option>
              <option value="Beauty, Spa and Salon">Beauty, Spa and Salon</option>
              <option value="Clothing and Apparel">Clothing and Apparel</option>
              <option value="Education">Education</option>
              <option value="Entertainment">Entertainment</option>
              <option value="Event Planning and Service">Event Planning and Service</option>
              <option value="Finance and Banking">Finance and Banking</option>
              <option value="Food and Grocery">Food and Grocery</option>
              <option value="Public Service">Public Service</option>
              <option value="Hotel and Lodging">Hotel and Lodging</option>
              <option value="Medical and Health">Medical and Health</option>
              <option value="Non-profit">Non-profit</option>
              <option value="Professional Services">Professional Services</option>
              <option value="Shopping and Retail">Shopping and Retail</option>
              <option value="Travel and Transportation">Travel and Transportation</option>
              <option value="Restaurant">Restaurant</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Contact email
            </label>
            <input type="text" id="bName" maxlength="256" [(ngModel)]="profileData.businessDetails.email"
              [disabled]="!CompanyProfilePermission.insertUpdate" placeholder="Enter your display name"
              class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary" />
            <div class="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-500">
              <span>
                Public contact email for your business
              </span>
              <span>
                {{ profileData.businessDetails.email?.length || 0 }} / 256 character
              </span>
            </div>
          </div>



          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Business website
            </label>
            <input type="text" id="bName" maxlength="256" [(ngModel)]="profileData.businessDetails.websites[0]"
              [disabled]="!CompanyProfilePermission.insertUpdate" placeholder="Enter your display name"
              class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary" />
            <div class="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-500">
              <span>
                Public URL to your business website
              </span>
              <span>
                {{
                (profileData.businessDetails.websites &&
                profileData.businessDetails.websites[0])
                ? profileData.businessDetails.websites[0].length
                : 0
                }} / 256 character
              </span>
            </div>
          </div>

          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Other URL
            </label>
            <input type="text" id="bName" maxlength="256" [(ngModel)]="profileData.businessDetails.websites[1]"
              [disabled]="!CompanyProfilePermission.insertUpdate" placeholder="Enter your display name"
              class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary" />
            <div class="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-500">
              <span>
                Public URL to one of your business websites, e.g. Instagram, Facebook profile, etc.
              </span>
              @if (profileData.businessDetails.websites[1]) {
              <span>
                {{ profileData.businessDetails.websites[1].length || 0 }} / 256 character
              </span>
              }
            </div>
          </div>
          <div class="tw-mb-3">
            <label for="bName" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
              Status text
            </label>
            <input type="text" id="bName" [(ngModel)]="profileData.businessDetails.about" maxlength="139"
              [disabled]="!CompanyProfilePermission.insertUpdate" placeholder="Enter your display name"
              class="tw-mt-1 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary" />
            <div class="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-500">
              <span>
                This is the status text displayed in your business profile on WhatsApp
              </span>
              <span>
                {{ profileData.businessDetails.about?.length || 0 }} / 139 character
              </span>
            </div>
          </div>

          <!-- Moved to Master > Settings page
          <div class="tw-mb-3">
            <h1 class="tw-text-2xl">Business Hours</h1>
            <span class="tw-text-gray-600 tw-text-sm">
              Set the days and times that your organization considers as your buisness/working hours
            </span>
          </div>
          <hr class="tw-py-2">
          @for (data of profileData.businessHours; track data) {
          <div class="tw-mb-2 tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-gap-4">
            <div class="md:tw-w-1/4 tw-flex tw-items-center tw-gap-3 tw-mb-2 md:tw-mb-0">
              <span class="tw-text-gray-700 tw-ps-2">
                {{ data.day }}
              </span>
            </div>
            <div class="md:tw-w-1/2 tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-2 md:tw-mb-0">
              <input type="time" [(ngModel)]="data.start" [disabled]="!CompanyProfilePermission.insertUpdate" class="tw-w-[45%] tw-rounded-md tw-border tw-border-gray-300
             tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none" />
              <input type="time" [(ngModel)]="data.end" [disabled]="!CompanyProfilePermission.insertUpdate" class="tw-w-[45%] tw-rounded-md tw-border tw-border-gray-300
             tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none" />
            </div>
            <div class="md:tw-w-1/4 tw-flex tw-items-center">
              <label class="tw-switch">
                <input [(ngModel)]="data.status" type="checkbox" role="switch"
                  [disabled]="!CompanyProfilePermission.insertUpdate" />
                <span class="tw-slider"></span>
              </label>
            </div>
          </div>
          }
          <div class="tw-my-3">
            <h1 class="tw-text-2xl">Queue - Archive Chats Settings</h1>
            <span class="tw-text-gray-600 tw-text-sm">
              Configure the days for The Queue and Archive Chats
            </span>
          </div>
          <hr class="tw-py-2">
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-1 tw-mb-4">
            <div class="md:tw-col-span-4">
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-700 tw-text-sm">
                  From Customer Last Messages Move to Queue Messages
                </span>
                <span class="tw-text-[11px] tw-text-red-600 tw-mt-1 tw-leading-tight">
                  Please enter absolute digit, floating points not allowed.
                  <br>
                  <span class="tw-font-bold">eg: 9</span>
                </span>
              </div>
            </div>
            <div class="md:tw-col-span-8 tw-flex tw-items-start tw-gap-2">
              <div class="tw-flex tw-items-center tw-gap-2 tw-w-full">
                <input type="number" [(ngModel)]="profileData.queueMessageDays"
                  [disabled]="!CompanyProfilePermission.insertUpdate"
                  class="tw-w-[35%] tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-md tw-shadow-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-green-500 focus:tw-border-green-500 tw-transition-all"
                  placeholder="0">
                <span class="tw-text-gray-700 tw-text-sm">Days</span>
              </div>
            </div>
          </div>
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-1 tw-mb-4">
            <div class="md:tw-col-span-4">
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-700 tw-text-sm">
                  From Customer Last Messages Move to Archive Messages
                </span>
                <span class="tw-text-[11px] tw-text-red-600 tw-mt-1 tw-leading-tight">
                  Please enter absolute digit, floating points not allowed.
                  <br>
                  <span class="tw-font-bold">eg: 9</span>
                </span>
              </div>
            </div>
            <div class="md:tw-col-span-8 tw-flex tw-items-start tw-gap-2">
              <div class="tw-flex tw-items-center tw-gap-2 tw-w-full">
                <input type="number" [(ngModel)]="profileData.archiveMessageDays"
                  [disabled]="!CompanyProfilePermission.insertUpdate"
                  class="tw-w-[35%] tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-md tw-shadow-sm focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-green-500 focus:tw-border-green-500 tw-transition-all"
                  placeholder="0">
                <span class="tw-text-gray-700 tw-text-sm">Days</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 my-3">
            <h1 class="tw-text-2xl">Default Country Code Settings</h1>
            <span class="tw-text-gray-600 tw-text-sm">
              Configure country code for WhatsApp Messages
            </span>
          </div>
          <hr class="tw-py-2">
          <div class="tw-flex tw-flex-col md:tw-flex-row tw-mb-2">
            <div class="md:tw-w-1/4 tw-flex tw-items-center tw-gap-3 tw-mb-2">
              <span class="tw-text-gray-700 tw-text-sm">
                Select Default Country Code
              </span>
            </div>
            <div class="tw-flex tw-items-center tw-gap-6 tw-flex-1">
              <div class="tw-flex tw-items-center">
                <label class="tw-switch">
                  <input type="checkbox" role="switch" [(ngModel)]="profileData.businessDetails.defaultcountry"
                    [disabled]="!CompanyProfilePermission.insertUpdate" />
                  <span class="tw-slider"></span>
                </label>
              </div>
              @if(profileData.businessDetails.defaultcountry){
              <div class="md:tw-w-1/2 tw-w-full">
                <ng-select [items]="countries" [(ngModel)]="profileData.businessDetails.defaultCountryCode"
                  [disabled]="!CompanyProfilePermission.insertUpdate" bindLabel="countryname"
                  bindValue="countrycallingcode" placeholder="Select Country" [searchable]="true">
                  <ng-template ng-option-tmp let-item="item">
                    <span class="tw-text-gray-700 tw-text-md">
                      {{ item.countryname }}
                    </span>
                    <h6 class="tw-text-sm">
                      Country Calling Code:
                      <b>+{{ item.countrycallingcode }}</b>
                    </h6>
                  </ng-template>
                </ng-select>
              </div>
              }
            </div>
          </div>
          End of moved section -->

        </div>
        @if (CompanyProfilePermission.insertUpdate) {
        <div class="tw-flex tw-justify-end tw-items-center tw-gap-2 tw-p-3 tw-border-t tw-border-gray-200">
          <button (click)="resetChanges()" type="button" class="tw-border tw-border-gray-300 tw-text-gray-700 tw-bg-white
           tw-px-4 tw-py-2 tw-rounded-md tw-text-sm hover:tw-bg-gray-50">
            Reset
          </button>
          <button (click)="saveChanges()" type="button" class="tw-bg-primary tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-text-sm
           hover:tw-bg-primary/90 focus:tw-outline-none">
            Save Changes
          </button>
        </div>
        }
      </div>
    </div>
    <div class="lg:tw-w-1/4 tw-w-full tw-mb-3">
      <div class="tw-bg-white tw-rounded-lg tw-shadow tw-px-3 tw-py-3 profilepreview">
        <h4>Preview</h4>
        <div
          class="tw-flex tw-items-center tw-justify-between tw-bg-primary tw-text-white tw-px-2 tw-py-1 tw-rounded-t-md mt-2">
          <span class="tw-text-sm">12:42</span>
          <span class="tw-flex tw-gap-1">
            <i class="ph ph-bell-simple-slash"></i>
            <i class="ph ph-cell-signal-high"></i>
            <i class="ph ph-battery-vertical-medium"></i>
          </span>
        </div>
        <div class="tw-relative tw-h-48 tw-bg-slate-400 tw-overflow-hidden">
          @if (previewUrl || profileData.businessLogo?.link) {
          <img [src]="previewUrl || profileData.businessLogo?.link || '/images/placeholder_img.jpg'"
            alt="Upload business logo"
            class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-shadow-inner"
            (error)="onLogoLoadError($event)">
          }
          <!-- <div
            class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-16 tw-bg-gradient-to-b tw-from-black/40 tw-to-transparent tw-pointer-events-none">
          </div> -->
          <div
            class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-flex tw-items-center tw-justify-between tw-p-2 tw-text-white tw-text-lg">
            <i class="ph-bold ph-arrow-left"></i>
            <i class="ph-duotone ph-dots-three-outline-vertical"></i>
          </div>
          <div
            class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-20 tw-bg-gradient-to-t tw-from-black/40 tw-to-transparent tw-pointer-events-none">
          </div>
          <div
            class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-px-3 tw-pb-3 tw-text-lg tw-font-semibold tw-text-white tw-truncate"
            style="text-shadow: 0 1px 2px rgba(0,0,0,0.9);" [title]="accountData[0]?.verifiedName">
            {{accountData[0]?.verifiedName}}
          </div>
        </div>
        <div class="tw-p-1 tw-bg-gray-300 tw-w-full"></div>
        <div class="tw-flex tw-flex-col tw-gap-1 tw-border-x tw-py-4">
          <div class="tw-flex tw-justify-around tw-items-center tw-w-full tw-gap-4 tw-p-2 ">
            <div class=" tw-text-2xl tw-text-primary">
              <i class="ph-duotone ph-storefront"></i>
            </div>
            <div class="tw-text-sm tw-w-full">
              {{profileData.businessDetails.description}}
            </div>
          </div>
          <div class="tw-flex tw-justify-around tw-items-center tw-w-full tw-gap-4 tw-p-2 ">
            <div class="tw-text-2xl tw-text-primary">
              <i class="ph-duotone ph-map-pin-area"></i>
            </div>
            <div class="tw-text-sm tw-w-full">
              {{profileData.businessDetails.address}}
            </div>
          </div>
          <div class="tw-flex tw-justify-around tw-items-center tw-w-full tw-gap-4 tw-p-2 ">
            <div class=" tw-text-2xl tw-text-primary ">
              <i class="ph-duotone ph-tag"></i>
            </div>
            <div class="tw-text-sm tw-w-full">
              {{profileData.businessDetails.vertical}}
            </div>
          </div>
          <div class="tw-flex tw-justify-around tw-items-center tw-w-full tw-gap-4 tw-p-2 ">
            <div class=" tw-text-2xl tw-text-primary ">
              <i class="ph-duotone ph-envelope-simple"></i>
            </div>
            <div class="tw-text-sm tw-w-full">
              {{profileData.businessDetails.email}}
            </div>
          </div>
          <div class="tw-flex tw-justify-around tw-items-center tw-w-full tw-gap-4 tw-p-2 ">
            <div class="tw-text-2xl tw-text-primary">
              <i class="ph ph-globe-hemisphere-west"></i>
            </div>
            <div class="tw-text-sm tw-w-full">
              <span class="tw-w-full tw-flex tw-justify-between align-items-start tw-flex-col">
                @for (item of profileData.businessDetails.websites; track $index) {
                <span class="break-normal">{{item}}</span>
                }
              </span>
            </div>
          </div>
        </div>
        <div class="tw-p-1 tw-bg-gray-300 tw-w-full"></div>
        <div class="tw-flex tw-flex-col tw-gap-1 tw-border-x tw-p-2">
          <div class="tw-my-3 tw-flex tw-flex-col tw-gap-3">
            <span class="tw-text-md tw-text-primary tw-capitalize">
              About and phone number
            </span>
            <span class="tw-text-[1rem]">
              {{profileData.businessDetails.about}}
            </span>
          </div>
          <hr class="tw-border-gray-500">
          <div class="tw-p-1 tw-py-2 tw-flex tw-justify-between tw-items-center tw-w-full">
            <span>{{profileData.parentNumber}}</span>
            <i class="ph-duotone ph-chat-text tw-text-3xl tw-text-primary"></i>
          </div>
        </div>
        <div class="tw-p-1 tw-bg-gray-300 tw-w-full"></div>
        <div class="tw-p-1 tw-bg-black tw-w-full tw-flex tw-py-3 rounded-bottom tw-justify-center tw-items-center mb-2">
          <span class="tw-w-[20%] tw-py-1 tw-rounded-md tw-bg-white"></span>
        </div>
      </div>
    </div>
  </div>
  }
</div>